import { hasEntitlement } from 'modules/Common/permissions/entitlements';

export const PlanSlug = Object.freeze({
  FreeTierSupplier: 'free_tier_supplier',
});

export const SupplierEntitlement = Object.freeze({
  Journey: 'lite_journey',
  FullPlatform: 'full_platform',
});

export const SUPPLIER_HOME_PATH = '/supplier';

export { hasEntitlement };

export const isFreeSupplierPlan = (me) => me?.plan === PlanSlug.FreeTierSupplier;

export const isFreeSupplier = (me) =>
  isFreeSupplierPlan(me) && hasEntitlement(me, SupplierEntitlement.Journey);

export const hasFullPlatform = (me) =>
  !isFreeSupplierPlan(me) && hasEntitlement(me, SupplierEntitlement.FullPlatform);
